import { useMemo } from "react";
import {
  Box,
  Grid,
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import FlexBetween from "../../components/FlexBetween";
import RuleExecutionTab from "../../components/Rules/RuleExecutionTab";
import useFetchFileProcessing from "../../hooks/useFetchFileProcessing";
import useFetchResourcesByIdMultipleIds from "../../hooks/useFetchResourcesByMultipleIds";
import useFetchRuleById from "../../hooks/useFetchRuleById";
import useFetchComparisonScoringConfig from "../../hooks/useFetchComparisonScoringConfig";
import {
  backgroundexecuteRuleById,
  executeRuleById,
  getUsedVariables,
} from "../../services/rulesService";
import ResultStorageParameters from "../../components/Rules/ResultStorageParameters";
import RunParameters from "../../components/Rules/RunParameters";
import ScoringConfigOverrideAccordion from "../../components/Scoring/ScoringConfigOverrideAccordion";
import {
  getDefaultRunParameters,
  getQueryParams,
} from "../../config/runParametersConfig";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { apiType, sqlDatabaseType } from "../../services/constants";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import RuleInlineVariables from "../../components/Rules/RuleInlineVariables";
import { useToast } from "../../services/utils";
import Loader from "../../components/Molecules/Loader/Loader";
import { extractConnectionKeyIds } from "../../utils/connectionKeyUtils";
import CustomAccordian from "../../components/Molecules/Accordian/CustomAccordion";
import FilterRules from "../../components/Resource/FilterRules";
import AddMultipleGridList from "../../components/AddMultipleGridList";
import ReadMoreLess from "../../components/ReadMoreLess";
import useFetchResearchQueryByRuleId from "../../hooks/useFetchResearchQueryByRuleId";
import { useBreadCrumbContext } from "../../contexts/BreadCrumbContext";
import { useRuleResourceContext } from "../../contexts/RuleResourceContext";
import { useSystemContext } from "../../contexts/TagAndSystemProvider";
import useFetchAllSystem from "../../hooks/useFetchAllSystem";
import CustomMultipleResourceRuleFilters from "../../components/Rules/CustomMultipleResourceRuleFilters";
import SecondaryMergeResourceDialog from "../../components/Dialogs/SecondaryMergeResourceDialog";
import useFetchResources from "../../hooks/useFetchResources";
import useFetchAllResourcesWithoutDomain from "../../hooks/useFetchAllResourcesWithoutDomain";
import useFetchLinkedServices from "../../hooks/useFetchLinkedServices";
import useFetchResourceColumnsByMultipleIds from "../../hooks/useFetchResourceColumnsByMultipleIds";
import {
  getSecondaryMergeResourcePayloadFields,
  getDifferentValues,
  processResourcesData,
} from "../../services/utils/processRuleExecutionResourcesData";
import { compareFilterRulesWithResourceId } from "../../services/utils/compareFilterRules";
import { executionNameSchema } from "../../schemas";
import ExecutionName from "../../components/Molecules/Rule/ExecutionName";
import { IconBtnEditBase } from "../../common/utils/icons";
import ViewPayloadDialog from "../../components/Dialogs/ViewPayloadDialog";
import { validateEngineRequest } from "../../services/resourcesService";
import { useAuth } from "../../contexts/AuthContext";
import RuleResearchQuery from "./RuleResearchQuery";
import useFetchAllConnectionKeyWithoutId from "../../hooks/useFetchAllConnectionKeyWithoutId";
import { getOptionalConfig } from "../../config/runtimeConfig";
interface FilterFormData {
  filter_rules: any[];
}

const RuleExecution = () => {
  const { setCurrentBreadcrumbPage } = useBreadCrumbContext();
  const { ruleId: currentRuleId } = useParams();
  const { showToast } = useToast();
  const {
    isResourceEdit,
    viewInlineVariables,
    setViewInlineVariables,
    setAllResourcesData,
    setLinkedServicesData,
    fileProcessingData,
    setFileProcessingData,
    setFetchedAllConnectionKeys,
    setResourceColumnsData,
    collectUsedVariables,
  } = useRuleResourceContext();
  const [resourceIds, setResourceIds] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isBackdropLoading, setIsBackdropLoading] = useState<boolean>(false);
  const [resourcesData, setResourcesData] = useState<any[]>([]);
  const [originalResourcesData, setOriginalResourcesData] = useState<any>({});
  const [isEditResource, setIsEditResource] = useState(false);
  const [resultStorageParameters, setResultStorageParameters] = useState<any>({
    linked_service_id: getOptionalConfig("REACT_APP_OUTPUT_STORAGE_LINKED_SERVICE_ID"),
    linked_service_code:
      getOptionalConfig("REACT_APP_OUTPUT_STORAGE_LINKED_SERVICE_CODE"),
    connection_key_id: getOptionalConfig("REACT_APP_OUTPUT_STORAGE_CONNECTION_KEY"),
    file_path: getOptionalConfig("REACT_APP_OUTPUT_FILES_BASE_PATH"),
  });
  const [originalResultStorageParameters, setOriginalResultStorageParameters] =
    useState<any>({
      linked_service_id: getOptionalConfig("REACT_APP_OUTPUT_STORAGE_LINKED_SERVICE_ID"),
      linked_service_code:
        getOptionalConfig("REACT_APP_OUTPUT_STORAGE_LINKED_SERVICE_CODE"),
      connection_key_id: getOptionalConfig("REACT_APP_OUTPUT_STORAGE_CONNECTION_KEY"),
      file_path: getOptionalConfig("REACT_APP_OUTPUT_FILES_BASE_PATH"),
    });

  const [ruleExecutionPayload, setRuleExecutionPayload] = useState<any>({});
  const [runParameters, setRunParameters] = useState<any>(
    getDefaultRunParameters("ruleExecution")
  );
  const [originalRunParameters, setOriginalRunParameters] = useState<any>(
    getDefaultRunParameters("ruleExecution")
  );
  const [scoreConfigOverride, setScoreConfigOverride] = useState<Record<
    string,
    any
  > | null>(null);

  const [severityColumnNames, setSeverityColumnNames] = useState<any>({
    low: null,
    medium: null,
    high: null,
  });
  const [originalSeverityColumnNames, setOriginalSeverityColumnNames] =
    useState<any>({
      low: null,
      medium: null,
      high: null,
    });

  // Original inline variables for differential comparison
  const [originalViewInlineVariables, setOriginalViewInlineVariables] =
    useState<any>({
      rule_variables: {
        filterRule: null,
        adhoc_queries: null,
      },
      resource_variables: [],
      comparison_research_query_variables: [],
      used_variables: {},
    });

  // Research Query state management for overriding functionality
  const [researchQueryDetailData, setResearchQueryDetailData] = useState<any>(
    {}
  );
  const [originalResearchQueryDetailData, setOriginalResearchQueryDetailData] =
    useState<any>({});
  const [isEditResearchQuery, setIsEditResearchQuery] = useState(false);

  const [secondaryMergeResourceDialog, setSecondaryMergeResourceDialog] =
    useState(false);
  const [resourceDataWithSecMerge, setResourceDataWithSecMerge] = useState<any>(
    {}
  );
  const [currentDomainId, setCurrentDomainId] = useState(null);
  const [ruleData] = useFetchRuleById({ setIsLoading, currentRuleId });
  const [comparisonScoringConfig] = useFetchComparisonScoringConfig({
    setIsLoading,
    ruleId: currentRuleId,
  });
  const [resourceData] = useFetchResourcesByIdMultipleIds({
    resourceIds,
    setIsLoading,
  });
  const [fileProcessing] = useFetchFileProcessing({ setIsLoading });
  const [researchQueryDetail] = useFetchResearchQueryByRuleId({
    setIsLoading,
    currentRuleId,
  });
  const [fetchedResourcesData] = useFetchResources({
    currentDomainId,
    setIsLoading,
  });
  const [allResources] = useFetchAllResourcesWithoutDomain({
    setIsLoading,
    aggregation_type: "aggregated",
  });
  const [linkedServices] = useFetchLinkedServices({ setIsLoading });
  // CRITICAL: Extract base resource IDs from fetched resources to fetch base resource data
  // This follows the same pattern as ValidateResource.tsx

  const baseResourceIds = useMemo(() => {
    if (!resourceData || !Array.isArray(resourceData)) {
      return [];
    }
    const baseIds: number[] = [];
    resourceData.forEach((resource: any) => {
      const baseResourceId =
        resource?.additional_properties?.aggregation_properties
          ?.base_resource_id;

      if (baseResourceId && baseResourceId > 0) {
        baseIds.push(baseResourceId);
      }
    });
    return Array.from(new Set(baseIds)); // Remove duplicates
  }, [resourceData]);

  // Fetch the actual base resource data
  const [baseResourcesData] = useFetchResourcesByIdMultipleIds({
    resourceIds: baseResourceIds,
    setIsLoading,
  });
  // Ref to maintain stable array references and prevent infinite loops
  const previousConnectionKeyIdsRef = useRef<number[]>([]);
  // OPTIMIZATION: Extract required connection key IDs from all resource data and linked services
  // This replaces the inefficient useFetchConnectionKeysAll call with targeted fetching
  const requiredConnectionKeyIds = useMemo(() => {
    if (
      !resourceData ||
      !Array.isArray(resourceData) ||
      resourceData.length === 0
    ) {
      return previousConnectionKeyIdsRef.current;
    }
    const allConnectionKeyIds = new Set<number>();
    // FIXED: Use extractConnectionKeyIds function for proper extraction from ExecuteRule data structure
    // ExecuteRule data structure is different from ReRunExecuteRule - it contains resource IDs, not expanded data
    resourceData.forEach((resource: any) => {
      // Extract connection keys using the utility function (same pattern as ValidateResource)
      const extractedIds = extractConnectionKeyIds(
        resource,
        resource?.additional_properties?.additional_resource_data,
        linkedServices,
        undefined, // outputStorageParams
        baseResourcesData // CRITICAL: Pass fetched base resource data instead of undefined
      );
      extractedIds.forEach((id: number) => {
        allConnectionKeyIds.add(id);
      });
    });
    // Convert to array and filter out null/undefined values
    const finalConnectionKeyIds = Array.from(allConnectionKeyIds).filter(
      (id) => id != null && id > 0
    );

    // CRITICAL FIX: Only return new array if IDs have actually changed
    const sortedIds = Array.from(new Set(finalConnectionKeyIds)).sort(
      (a, b) => a - b
    );
    const previousIds = previousConnectionKeyIdsRef.current;

    // Compare arrays to prevent infinite loops
    const idsChanged =
      sortedIds.length !== previousIds.length ||
      sortedIds.some((id, index) => id !== previousIds[index]);

    if (idsChanged) {
      previousConnectionKeyIdsRef.current = sortedIds;
      return sortedIds;
    } else {
      return previousConnectionKeyIdsRef.current;
    }
  }, [resourceData, linkedServices, ruleData, baseResourcesData]);
  // Fetch only the specific connection keys needed (optimized API call)
  const [fetchedConnectionKeys] = useFetchAllConnectionKeyWithoutId({
    setIsLoading,
  });
  // Get the setter function from context (following linkedServicesData pattern)
  const { setAllSystemData } = useSystemContext();
  // Fetch system data directly in this component (following linkedServicesData pattern)
  const [systemData] = useFetchAllSystem({
    setIsLoading,
  });
  // Update context state when system data is fetched (following linkedServicesData pattern)
  useEffect(() => {
    if (systemData && Array.isArray(systemData)) {
      setAllSystemData(systemData);
    }
  }, [systemData, setAllSystemData]);

  // Extract resource column IDs from all resources and their additional resources
  // This enables column merging in LinkedServices component for RuleExecution workflow
  const resourceColumnIds = useMemo(() => {
    const colIds: number[] = [];

    if (
      !originalResourcesData ||
      !Array.isArray(originalResourcesData) ||
      !allResources
    ) {
      return colIds;
    }

    // Iterate through all main resources
    originalResourcesData.forEach((resource: any) => {
      // Add main resource column ID
      const mainColId =
        resource?.additional_properties?.resource_column_details_id;
      if (mainColId && !colIds.includes(mainColId)) {
        colIds.push(mainColId);
      }

      // Add additional resource column IDs
      const additionalResources =
        resource?.additional_properties?.additional_resource_data;
      if (additionalResources && Array.isArray(additionalResources)) {
        additionalResources.forEach((addRes: any) => {
          //get resource_id from additional_resource_data
          //get resource_column_details_id from allResourcesData
          const addColId = allResources?.find(
            (res1: { id: number }) => res1.id === addRes.resource_id
          )?.additional_properties?.resource_column_details_id;

          if (addColId && !colIds.includes(addColId)) {
            colIds.push(addColId);
          }
        });
      }
    });

    return colIds;
  }, [originalResourcesData, allResources]);

  // Fetch resource columns for all resources (main + additional)
  const [resourceColumns] = useFetchResourceColumnsByMultipleIds({
    resourceColIds: resourceColumnIds,
    setIsLoading,
  });

  const [expandedAccordion, setExpandedAccordion] = useState<any>("");
  const [validationMessage, setValidationMessage] = useState<any[]>([]);
  const [checkValidation, setCheckValidation] = useState(false);

  const [inlineVariables, setInlineVariables] = useState<any>({
    rule_variables: {
      filterRule: null,
      adhoc_queries: null,
    },
    resource_variables: [],
    comparison_research_query_variables: [],
    used_variables: {},
  });
  const [isEditVariables, setIsEditVariables] = useState(false);
  const [isEditFilters, setIsEditFilters] = useState(false);
  const [filterFormData, setFilterFormData] = useState<
    FilterFormData | undefined
  >(undefined);
  const [initialInlineVariables, setInitialInlineVariables] = useState<any>({});
  const [hasChanges, setHasChanges] = useState<boolean>(false);
  const [secondaryResourceData, setSecondaryResourceData] = useState<any[]>([]);
  const [fetchSecondaryResourceData, setFetchSecondaryResourceData] = useState<
    any[]
  >([]);
  const [allRepeatedResources, setAllRepeatedResources] = useState<any[]>([]);
  const [isEditSecondaryResource, setIsEditSecondaryResource] = useState(false);
  const [mergeColumnsLength, setMergeColumnsLength] = useState(0);
  const [isReRunData, setIsReRunData] = useState<any>({
    executionID: null,
    isReRun: false,
  });
  const [executionName, setExecutionName] = useState("");
  const [executionMode, setExecutionMode] = useState(true);
  const [showVariables, setShowVariables] = useState("used");
  const [errors, setErrors] = useState<{ [key: string]: any }>({
    execution_name: "",
  });
  const [isPayloadDialogOpen, setIsPayloadDialogOpen] = useState(false);
  const [executeRulePayload, setExecuteRulePayload] = useState<any>(null);
  const [validationResponse, setValidationResponse] = useState<any>(null);
  const [isValidating, setIsValidating] = useState(false);

  const isUpdateRepeatedResourcesCalled = useRef(false);

  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const reRun = params.get("re-run");
    const executionId = params.get("execution-id");
    if (reRun && executionId) {
      setIsReRunData({
        executionID: Number(executionId),
        isReRun: true,
      });
    } else {
      setIsReRunData({
        executionID: null,
        isReRun: false,
      });
    }
  }, [location]);

  useEffect(() => {
    if (allResources) {
      setAllResourcesData(allResources);
    }
  }, [allResources, setAllResourcesData]);

  useEffect(() => {
    if (linkedServices) {
      setLinkedServicesData(linkedServices);
    }
  }, [linkedServices, setLinkedServicesData]);

  // Initialize original parameter values on component mount
  // This captures the baseline state for differential comparison
  useEffect(() => {
    // Set original values as deep copies to prevent reference issues
    setOriginalResultStorageParameters(
      JSON.parse(JSON.stringify(resultStorageParameters))
    );
    setOriginalRunParameters(JSON.parse(JSON.stringify(runParameters)));
    setOriginalSeverityColumnNames(
      JSON.parse(JSON.stringify(severityColumnNames))
    );
    setOriginalViewInlineVariables(
      JSON.parse(JSON.stringify(viewInlineVariables))
    );
  }, []); // Empty dependency array - run only once on mount

  useEffect(() => {
    if (fileProcessing) {
      setFileProcessingData(fileProcessing);
    }
  }, [fileProcessing, setFileProcessingData]);

  useEffect(() => {
    if (fetchedConnectionKeys) {
      setFetchedAllConnectionKeys(fetchedConnectionKeys);
    }
  }, [fetchedConnectionKeys, setFetchedAllConnectionKeys]);

  // Set resource columns data in context for column merging in LinkedServices
  useEffect(() => {
    if (resourceColumns?.length > 0) {
      setResourceColumnsData(resourceColumns);
    }
  }, [resourceColumns, setResourceColumnsData]);

  useEffect(() => {
    const fetchUsedVariables = async () => {
      const usedVariables = await getUsedVariables(ruleData?.id);
      if (allRepeatedResources && allRepeatedResources.length > 0) {
        const resourceInlineVariables: any[] = allRepeatedResources
          .map((res: any) => {
            if (
              res?.additional_properties?.inline_variables &&
              Object.keys(res?.additional_properties?.inline_variables).length >
                0
            ) {
              return {
                resource_id: res?.id,
                resource_vars: res?.additional_properties?.inline_variables,
                resource_name: res?.resource_name,
              };
            }
            return null;
          })
          .filter(Boolean);

        // Map through resource_variables and add resource_col_detail_id
        const updatedResourceVariables =
          resourceInlineVariables?.length > 0
            ? resourceInlineVariables?.map((resourceVar: any) => {
                const matchedResource = resourceData?.find(
                  (res: any) => res?.id === resourceVar?.resource_id
                );

                return {
                  ...resourceVar,
                  resource_col_detail_id:
                    matchedResource?.additional_properties
                      ?.resource_column_details_id,
                };
              })
            : [];

        const enhancedUsedResources = (usedVariables?.resources || []).map(
          (resource: any) => {
            const mergedVarsSet = collectUsedVariables(resource);
            return {
              resource_id: resource.resource_id,
              merged_used_variables: Array.from(mergedVarsSet),
            };
          }
        );

        setInlineVariables((prev: any) => ({
          ...prev,
          resource_variables: updatedResourceVariables,
          used_variables: enhancedUsedResources,
          used_rule_variables: usedVariables?.rule_variables,
          used_research_query_variables:
            usedVariables?.research_queries?.[0]?.variables,
        }));
        setViewInlineVariables((prev: any) => ({
          ...prev,
          resource_variables: updatedResourceVariables,
          used_variables: enhancedUsedResources,
          used_rule_variables: usedVariables?.rule_variables,
          used_research_query_variables:
            usedVariables?.research_queries?.[0]?.variables,
        }));
        setInitialInlineVariables((prev: any) => ({
          ...prev,
          resource_variables: updatedResourceVariables,
          used_variables: enhancedUsedResources,
          used_rule_variables: usedVariables?.rule_variables,
          used_research_query_variables:
            usedVariables?.research_queries?.[0]?.variables,
        }));
      }
    };
    if (!ruleData?.id || allRepeatedResources?.length <= 0) return;
    fetchUsedVariables();
  }, [ruleData?.id, allRepeatedResources]);

  useEffect(() => {
    let resourceIds: any[] = ruleData?.rule_schema?.resources ?? [];
    let externalResourceIds: any[] = [];
    let secondaryResource: any[] = [];
    setCurrentDomainId(ruleData?.domain_id);
    const adhocQueriesInlineVariables: any = {};

    if (researchQueryDetail?.research_queries?.length > 0) {
      researchQueryDetail.research_queries.forEach((query: any) => {
        if (query?.source?.length > 0) {
          query.source.forEach((source: any) => {
            // Check if type is Resource or if type is Mixed with sub_type Resource
            if (
              (source?.type === "Resource" && source?.resource_id) ||
              (source?.type === "Mixed" &&
                source?.sub_type === "Resource" &&
                source?.resource_id)
            ) {
              externalResourceIds.push(source?.resource_id);
            }
          });
        }
      });
      if (externalResourceIds.length > 0) {
        resourceIds = [...resourceIds, ...externalResourceIds];
      }
    }
    // Process primary dataset's secondary merge resources
    const primaryResourceIds = ruleData?.rule_schema?.merge_rule
      ?.primary_dataset?.secondary_merge_resource?.resource_id
      ? ruleData.rule_schema.merge_rule.primary_dataset.secondary_merge_resource
          .resource_id
      : null;

    if (primaryResourceIds) {
      resourceIds = [...resourceIds, primaryResourceIds];
      secondaryResource.push({
        parentResId:
          ruleData?.rule_schema?.merge_rule?.primary_dataset?.resource_id,
        secondaryResId: primaryResourceIds,
        secondary_merge_resource:
          ruleData.rule_schema.merge_rule.primary_dataset
            .secondary_merge_resource,
      });
    }

    // Process secondary datasets
    const secondaryDatasets =
      ruleData?.rule_schema?.merge_rule?.secondary_datasets ?? [];
    if (secondaryDatasets.length > 0) {
      const secResIds = secondaryDatasets
        .map((res: any) => res.secondary_merge_resource?.resource_id || [])
        .flat();

      if (secResIds.length > 0) {
        resourceIds = [...resourceIds, ...secResIds];

        const secRes = secondaryDatasets.map((res: any) => ({
          parentResId: res?.resource_id,
          secondaryResId: res?.secondary_merge_resource?.resource_id || null,
          secondary_merge_resource: res?.secondary_merge_resource,
        }));
        secondaryResource = [...secondaryResource, ...secRes];
      }
    }

    setFetchSecondaryResourceData(secondaryResource);
    setResourceIds(resourceIds);

    ruleData?.rule_schema?.adhoc_queries?.forEach(
      (obj: { inline_variables: { name: any; value: any }[] }) => {
        obj.inline_variables?.forEach(({ name, value }) => {
          adhocQueriesInlineVariables[name] = value;
        });
      }
    );

    setInlineVariables((prev: any) => ({
      ...prev,
      rule_variables: {
        filterRule: ruleData?.rule_schema?.inline_variables,
        adhoc_queries: adhocQueriesInlineVariables,
      },
    }));
    setViewInlineVariables((prev: any) => ({
      ...prev,
      rule_variables: {
        filterRule: ruleData?.rule_schema?.inline_variables,
        adhoc_queries: adhocQueriesInlineVariables,
      },
    }));
    setInitialInlineVariables((prev: any) =>
      JSON.parse(
        JSON.stringify({
          ...prev,
          rule_variables: {
            filterRule: ruleData?.rule_schema?.inline_variables,
            adhoc_queries: adhocQueriesInlineVariables,
          },
        })
      )
    );
    setFilterFormData(ruleData?.rule_schema);
    setExecutionName(ruleData?.name);
  }, [ruleData, researchQueryDetail]);
  // Update hasChanges when formData or fileData changes
  useEffect(() => {
    const inlineVariablesChanged =
      JSON.stringify(inlineVariables) !==
      JSON.stringify(initialInlineVariables);

    setHasChanges(inlineVariablesChanged);
  }, [inlineVariables, initialInlineVariables]);

  useEffect(() => {
    //set primary merge column Length
    const columnLength: number = ruleData?.rule_schema?.merge_rule
      ?.primary_dataset?.merge_on
      ? ruleData?.rule_schema?.merge_rule?.primary_dataset?.merge_on?.length
      : 0;

    setMergeColumnsLength(columnLength);
  }, [ruleData, researchQueryDetail]);

  useEffect(() => {
    if (fetchSecondaryResourceData) {
      setSecondaryResourceData(fetchSecondaryResourceData);
    }
  }, [fetchSecondaryResourceData]);

  useEffect(() => {
    if (
      resourceData?.length > 0 &&
      resourceIds?.length > 0 &&
      fetchSecondaryResourceData?.length > 0 &&
      !isUpdateRepeatedResourcesCalled.current
    ) {
      isUpdateRepeatedResourcesCalled.current = true;

      const repeatedResources = resourceIds
        .map((id) => {
          const resource = resourceData.find(
            (resource: { id: any }) => resource.id === id
          );

          return resource
            ? {
                ...resource,
              }
            : null;
        })
        .filter((resource) => resource !== null);

      const updatedAllResource = updateRepeatedResources(
        fetchSecondaryResourceData,
        repeatedResources
      );
      setAllRepeatedResources(updatedAllResource);
    } else if (fetchSecondaryResourceData?.length <= 0) {
      setAllRepeatedResources(resourceData);
    }
  }, [resourceData, resourceIds, fetchSecondaryResourceData]);

  useEffect(() => {
    setCurrentBreadcrumbPage({
      name: ruleData?.name,
      id: ruleData?.id,
    });
    return () => {
      setCurrentBreadcrumbPage({ name: "", id: null });
    };
  }, [ruleData]);

  const comparisonCheckNameOptions = useMemo<string[]>(() => {
    const domainNames = (
      ruleData?.rule_schema?.domain_comparison_rules || []
    ).map((r: any) => r.name);
    const customNames = (
      ruleData?.rule_schema?.custom_comparison_rules || []
    ).map((r: any) => r.name);
    return [...domainNames, ...customNames].filter(Boolean);
  }, [ruleData]);

  useEffect(() => {
    if (researchQueryDetail) {
      // Set research query detail data for overriding functionality
      setResearchQueryDetailData(researchQueryDetail);
      setOriginalResearchQueryDetailData(
        JSON.parse(JSON.stringify(researchQueryDetail))
      );

      setInlineVariables((prev: any) => ({
        ...prev,
        comparison_research_query_variables: researchQueryDetail?.variables,
      }));
      setViewInlineVariables((prev: any) => ({
        ...prev,
        comparison_research_query_variables: researchQueryDetail?.variables,
      }));
      setInitialInlineVariables((prev: any) => ({
        ...prev,
        comparison_research_query_variables: researchQueryDetail?.variables,
      }));
    }
  }, [researchQueryDetail, setViewInlineVariables]);
  useEffect(() => {
    const fetchData = async () => {
      const sortedResources = await processResourcesData({
        allRepeatedResources,
        fetchedConnectionKeys,
        secondaryResourceData: fetchSecondaryResourceData,
      });
      setResourcesData(sortedResources);
      setOriginalResourcesData(JSON.parse(JSON.stringify(sortedResources)));
    };

    fetchData();
  }, [allRepeatedResources, fetchedConnectionKeys, fetchSecondaryResourceData]);

  // useEffect(() => {
  //   if (allRepeatedResources && allRepeatedResources.length > 0) {
  //     const resourceInlineVariables: any[] = allRepeatedResources
  //       .map((res: any) => {
  //         if (
  //           res?.additional_properties?.inline_variables &&
  //           Object.keys(res?.additional_properties?.inline_variables).length > 0
  //         ) {
  //           return {
  //             resource_id: res?.id,
  //             resource_vars: res?.additional_properties?.inline_variables,
  //             resource_name: res?.resource_name,
  //           };
  //         }
  //         return null;
  //       })
  //       .filter(Boolean);
  //     setInlineVariables((prev: any) => ({
  //       ...prev,
  //       resource_variables: resourceInlineVariables,
  //     }));
  //     setViewInlineVariables((prev: any) => ({
  //       ...prev,
  //       resource_variables: resourceInlineVariables,
  //     }));
  //     setInitialInlineVariables((prev: any) => ({
  //       ...prev,
  //       resource_variables: resourceInlineVariables,
  //     }));
  //   }
  // }, [allRepeatedResources]);

  const updateRepeatedResources = (
    secondaryResourceData: any[],
    repeatedResources: any[]
  ) => {
    // Iterate through secondaryResourceData
    secondaryResourceData.forEach(
      (secondaryData: { secondaryResId: any; parentResId: any }) => {
        const { secondaryResId, parentResId } = secondaryData;

        // Find the first object in repeatedResources that matches the secondaryResId
        const targetResource = repeatedResources.find(
          (resource: { id: any; isSecondaryResource: any; parentResId: any }) =>
            resource.id === secondaryResId &&
            resource?.isSecondaryResource === undefined
        );

        // If found, add the required keys
        if (targetResource) {
          targetResource.isSecondaryResource = true;
          targetResource.parentResId = parentResId;
        }
      }
    );
    // Return the updated repeatedResources for testing purposes
    return repeatedResources;
  };

  const getComparisonSymbol = (comparisonType: string | number) => {
    const symbolMap: { [key: string]: string } = {
      equals: "=",
      "not equals": "!=",
      "greater than": ">",
      "less than": "<",
    };
    return symbolMap[comparisonType] || comparisonType;
  };
  const getResourceNamebyId = (
    resourceId: number | string | null | undefined
  ) => {
    if (!allRepeatedResources) {
      return undefined;
    }
    const matchingResource = allRepeatedResources?.find(
      (resource: { id: string | number | null | undefined }) =>
        resource.id === resourceId
    );
    return matchingResource ? matchingResource.resource_name : undefined;
  };
  const getFilePreProcessing = (id: string | number | undefined) => {
    const filePreProcessing = fileProcessingData?.find(
      (file: { id: string | number | null | undefined }) => file.id === id
    );
    return filePreProcessing
      ? filePreProcessing.file_processing_attributes
      : undefined;
  };
  const getApiDefinition = (resource: any) => {
    let user_name =
      resource?.additional_properties?.resource_definition?.api_definition
        ?.user_name || null;
    let password =
      resource?.additional_properties?.resource_definition?.api_definition
        ?.password || null;
    let bearer_token =
      resource?.additional_properties?.resource_definition?.api_definition
        ?.bearer_token || null;
    let api_key =
      resource?.additional_properties?.resource_definition?.api_definition
        ?.api_key || null;
    let oauth_client_id =
      resource?.additional_properties?.resource_definition?.api_definition
        ?.oauth_client_id || null;
    let oauth_client_secret =
      resource?.additional_properties?.resource_definition?.api_definition
        ?.oauth_client_secret || null;
    let oauth_url =
      resource?.additional_properties?.resource_definition?.api_definition
        ?.oauth_url || null;
    let method =
      resource?.additional_properties?.resource_definition?.api_definition
        ?.method || "get";
    let content_type =
      resource?.additional_properties?.resource_definition?.api_definition
        ?.content_type || "application/json";
    let body =
      resource?.additional_properties?.resource_definition?.api_definition
        ?.body || null;
    let query_params =
      resource?.additional_properties?.resource_definition?.api_definition
        ?.query_params || null;
    let url_params =
      resource?.additional_properties?.resource_definition?.api_definition
        ?.url_params || null;
    let url =
      resource?.additional_properties?.resource_definition?.api_definition
        ?.url || null;
    let request_timeout =
      resource?.additional_properties?.resource_definition?.api_definition
        ?.request_timeout || 0;
    return {
      user_name,
      password,
      bearer_token,
      api_key,
      oauth_client_id,
      oauth_client_secret,
      oauth_url,
      method,
      content_type,
      body,
      query_params,
      url_params,
      url,
      request_timeout,
    };
  };
  const getResourceDefinition = (resource: any, type: string) => {
    let connection_key = null;
    let container_name = null;
    let resource_path = null;
    let file_name = null;
    let excel_sheet_name = null;
    let column_delimiter = null;
    let sql_query = null;
    let use_multi_thread_reader = false;
    let column_name_to_partition_on_sql_query = null;
    let use_parquet_export = false;
    let parquet_export_definition = null;
    const resourceDef = resource?.additional_properties?.resource_definition;
    if (type === "blob") {
      connection_key = resourceDef?.connection_key || null;
      container_name = resourceDef?.container_name || null;
      resource_path = resourceDef?.resource_path || null;
      file_name = resourceDef?.file_name || null;
      excel_sheet_name = resourceDef?.excel_sheet_name || null;
      column_delimiter = resourceDef?.column_delimiter || null;
    } else if (type === "sftp") {
      connection_key = resourceDef?.connection_key || null;
      resource_path = resourceDef?.remote_directory || null;
      file_name = resourceDef?.file_name || null;
      excel_sheet_name = resourceDef?.excel_sheet_name || null;
      column_delimiter = resourceDef?.column_delimiter || null;
    } else if (type === "local") {
      connection_key = resourceDef?.connection_key || null;
      resource_path = resourceDef?.resource_path || null;
      file_name = resourceDef?.file_name || null;
      excel_sheet_name = resourceDef?.excel_sheet_name || null;
      column_delimiter = resourceDef?.column_delimiter || null;
    } else if (sqlDatabaseType.includes(type)) {
      sql_query = resourceDef?.sql_query || null;
      connection_key = resourceDef?.connection_key || null;
      use_multi_thread_reader =
        resourceDef?.sql_definition?.use_multi_thread_reader || false;
      column_name_to_partition_on_sql_query =
        resourceDef?.sql_definition?.column_name_to_partition_on_sql_query ||
        null;
      use_parquet_export = resourceDef?.use_parquet_export || false;
      parquet_export_definition = resourceDef?.use_parquet_export
        ? resourceDef?.parquet_export_definition || null
        : null;
    } else if (apiType.includes(type)) {
      connection_key = resourceDef?.api_definition?.connection_key || null;
    }

    return {
      connection_key,
      container_name,
      resource_path,
      file_name,
      excel_sheet_name,
      column_delimiter,
      sql_query,
      use_multi_thread_reader,
      column_name_to_partition_on_sql_query,
      use_parquet_export,
      parquet_export_definition,
    };
  };

  const processAdditionalResourceData = (additionalResourceData: any) => {
    if (!Array.isArray(additionalResourceData)) {
      return null;
    }
    const res = additionalResourceData
      .map((resource) => getResourceReqBody(resource))
      .filter(Boolean);
    return res;
  };

  const getResourceReqBody = (resource: any) => {
    const aggregationType = resource?.aggregation_type;
    const type = resource?.additional_properties?.resource_definition?.type;

    if (!aggregationType || (aggregationType === "flat" && !type)) {
      return null;
    }

    const additional_base_resource_data =
      resource?.additional_properties?.additional_resource_data?.length > 0
        ? processAdditionalResourceData(
            resource?.additional_properties?.additional_resource_data
          )
        : null;

    let resourceObject: any = {
      aggregation_type: aggregationType,
      resource_column_details_id:
        resource?.additional_properties?.resource_column_details_id,
      resource_name: resource?.resource_name,
      resource_id: resource?.id || null,
      linked_service_id: resource?.linked_service_id || null,
      linked_service_code: resource?.linked_service_code || null,
      file_processing_id: resource?.file_processing_id,
      is_secondary_resource: resource?.isSecondaryResource
        ? resource?.isSecondaryResource
        : false,
      additional_base_resource_data,
      filter_rules: resource?.additional_properties?.filter_rules,
    };

    // FLAT resources: add definition and API-related info
    if (aggregationType === "flat") {
      const {
        connection_key,
        container_name,
        resource_path,
        file_name,
        excel_sheet_name,
        column_delimiter,
        sql_query,
        use_multi_thread_reader,
        column_name_to_partition_on_sql_query,
        use_parquet_export,
        parquet_export_definition,
      } = getResourceDefinition(resource, type);

      const {
        user_name,
        password,
        bearer_token,
        api_key,
        oauth_client_id,
        oauth_client_secret,
        oauth_url,
        method,
        content_type,
        body,
        query_params,
        url_params,
        url,
        request_timeout,
      } = getApiDefinition(resource);

      const file_pre_processing =
        sqlDatabaseType.includes(type) || apiType.includes(type)
          ? null
          : getFilePreProcessing(resource?.file_processing_id);

      const api_request = apiType.includes(type)
        ? {
            user_name,
            password,
            bearer_token,
            api_key,
            oauth_client_id,
            oauth_client_secret,
            oauth_url,
            method,
            content_type,
            body,
            query_params,
            url_params,
            url,
            request_timeout,
          }
        : null;

      resourceObject = {
        ...resourceObject,
        connection_key,
        sql_query,
        container_name,
        resource_path,
        file_name,
        excel_sheet_name,
        column_delimiter,
        file_pre_processing,
        api_request,
        use_multi_thread_reader,
        column_name_to_partition_on_sql_query,
        use_parquet_export,
        parquet_export_definition,
      };
    }

    // AGGREGATED resources: include aggregation props and recurse
    if (aggregationType === "aggregated") {
      const aggregation_properties = {
        base_resource_id:
          resource?.additional_properties?.aggregation_properties
            ?.base_resource_id,
        base_resource_code:
          resource?.additional_properties?.aggregation_properties
            ?.base_resource_code,
        aggregation_query:
          resource?.additional_properties?.aggregation_properties
            ?.aggregation_query,
        base_resource_columns:
          resource?.additional_properties?.aggregation_properties
            ?.base_resource_columns,
        base_resource_validation:
          resource?.additional_properties?.aggregation_properties
            ?.base_resource_validation,
      };

      resourceObject = {
        ...resourceObject,
        aggregation_properties,
        aggregation_base_resource_data: getResourceReqBody(
          resource?.additional_properties?.aggregation_properties
        ),
      };
    }

    // Remove null/undefined values
    resourceObject = Object.fromEntries(
      Object.entries(resourceObject).filter(
        ([_, v]) => v !== null && v !== undefined
      )
    );

    const cleanedResourceObject = Object.fromEntries(
      Object.entries(resourceObject).filter(([key]) => key !== "type")
    );

    return Object.keys(cleanedResourceObject).length
      ? cleanedResourceObject
      : null;
  };

  // Extracted function to build rule execution payload without side effects
  const buildRuleExecutionPayload = () => {
    // Build current output storage params
    let output_storage_params = {
      output_storage_linked_service_id:
        resultStorageParameters?.linked_service_id || null,
      output_storage_linked_service_code:
        resultStorageParameters?.linked_service_code || null,
      output_storage_connection_key:
        resultStorageParameters?.connection_key_id || null,
      output_storage_base_file_path: resultStorageParameters?.file_path || null,
    };

    // Build original output storage params for comparison
    let original_output_storage_params = {
      output_storage_linked_service_id:
        originalResultStorageParameters?.linked_service_id || null,
      output_storage_linked_service_code:
        originalResultStorageParameters?.linked_service_code || null,
      output_storage_connection_key:
        originalResultStorageParameters?.connection_key_id || null,
      output_storage_base_file_path:
        originalResultStorageParameters?.file_path || null,
    };

    const isOutputStorageParamsNull = Object.values(output_storage_params).some(
      (value) => value === null
    );

    // Compare output storage params and only include if changed
    const differentOutputStorageParams = getDifferentValues(
      output_storage_params,
      original_output_storage_params
    );

    let severityColumnNamesPayload = {
      1: severityColumnNames.high,
      2: severityColumnNames.medium,
      3: severityColumnNames.low,
    };
    const severity_column_names = Object.fromEntries(
      Object.entries(severityColumnNamesPayload).filter(([_, v]) => v !== null)
    );

    let resourceData = resourcesData.map((resource: any) => {
      let resourceObject: any = getResourceReqBody(resource);
      resourceObject = {
        ...resourceObject,
        ...getSecondaryMergeResourcePayloadFields(resource),
      };

      // checkRequiredValidation(resource, resourceObject);

      resourceObject = Object.fromEntries(
        Object.entries(resourceObject).filter(([_, v]) => v !== null)
      );

      return resourceObject;
    });

    const originalResourceData = originalResourcesData.map(
      (resource: any) => {
        let resourceObject: any = getResourceReqBody(resource);
        resourceObject = {
          ...resourceObject,
          // secondary_merge_resource:
          //   resource?.secondary_merge_resource?.secondary_merge_resource,
          // secondary_merge_resource_parent_id: secondaryMergeResourceParentId,
        };

        resourceObject = Object.fromEntries(
          Object.entries(resourceObject).filter(([_, v]) => v !== null)
        );

        return resourceObject;
      }
    );

    // Get only the different values between resourceObject and originalResourcesObject
    resourceData = getDifferentValues(resourceData, originalResourceData);

    // Extract only backend-expected query params (excludes FE-only fields)
    const filteredRunParameters = getQueryParams(
      "ruleExecution",
      runParameters
    );

    // Build current run_instance
    const current_run_instance = {
      run_id: runParameters?.run_instance?.run_id || 1,
      run_name: runParameters?.run_instance?.run_name || "Legacy",
    };

    // Build original run_instance for comparison
    const original_run_instance = {
      run_id: originalRunParameters?.run_instance?.run_id || 1,
      run_name: originalRunParameters?.run_instance?.run_name || "Legacy",
    };

    // Compare run_instance and only include if changed
    const differentRunInstance = getDifferentValues(
      current_run_instance,
      original_run_instance
    );

    // Build current execution_sub_group
    const current_execution_sub_group = {
      execution_sub_group_id:
        runParameters?.execution_sub_group?.execution_sub_group_id || 0,
      execution_sub_group_code:
        runParameters?.execution_sub_group?.execution_sub_group_code || "",
    };

    // Build original execution_sub_group for comparison
    const original_execution_sub_group = {
      execution_sub_group_id:
        originalRunParameters?.execution_sub_group?.execution_sub_group_id || 0,
      execution_sub_group_code:
        originalRunParameters?.execution_sub_group?.execution_sub_group_code ||
        "",
    };

    // Compare execution_sub_group and only include if changed
    const differentExecutionSubGroup = getDifferentValues(
      current_execution_sub_group,
      original_execution_sub_group
    );

    // Calculate current severity level
    const current_severity_level =
      runParameters?.validation_severity_level === "high"
        ? 1
        : runParameters?.validation_severity_level === "medium"
        ? 2
        : 3;

    // Calculate original severity level
    const original_severity_level =
      originalRunParameters?.validation_severity_level === "high"
        ? 1
        : originalRunParameters?.validation_severity_level === "medium"
        ? 2
        : 3;

    // Get current and original report names
    const current_rule_execution_report_name =
      resultStorageParameters?.rule_execution_report_name || null;
    const original_rule_execution_report_name =
      originalResultStorageParameters?.rule_execution_report_name || null;

    const current_validation_execution_report_name =
      resultStorageParameters?.validation_execution_report_name || null;
    const original_validation_execution_report_name =
      originalResultStorageParameters?.validation_execution_report_name || null;

    // Build current inline_variables
    const current_inline_variables = {
      comparison_research_query_variables:
        viewInlineVariables?.comparison_research_query_variables,
      resource_variables: viewInlineVariables?.resource_variables
        ? viewInlineVariables?.resource_variables.map((item: any) => {
            return {
              resource_id: item?.resource_id,
              resource_vars: item?.resource_vars,
            };
          })
        : [],
      rule_variables: {
        ...viewInlineVariables?.rule_variables?.filterRule,
        ...viewInlineVariables?.rule_variables?.adhoc_queries,
      },
    };

    // Build original inline_variables for comparison
    const original_inline_variables = {
      comparison_research_query_variables:
        originalViewInlineVariables?.comparison_research_query_variables,
      resource_variables: originalViewInlineVariables?.resource_variables
        ? originalViewInlineVariables?.resource_variables.map((item: any) => {
            return {
              resource_id: item?.resource_id,
              resource_vars: item?.resource_vars,
            };
          })
        : [],
      rule_variables: {
        ...originalViewInlineVariables?.rule_variables?.filterRule,
        ...originalViewInlineVariables?.rule_variables?.adhoc_queries,
      },
    };

    // Compare inline_variables and only include if changed
    const differentInlineVariables = getDifferentValues(
      current_inline_variables,
      original_inline_variables
    );

    const cleanedResearchQueries =
      researchQueryDetailData?.research_queries?.map(
        ({ updatedQuery, ...rest }: any) => rest
      ) || [];

    // Build base payload with always-required fields
    const reqBody: any = {
      resource_data: resourceData ? resourceData : [],
      research_queries: cleanedResearchQueries || [],
      filter_rules: compareFilterRulesWithResourceId(
        ruleData?.rule_schema?.filter_rules,
        filterFormData?.filter_rules
      ),
      execution_name: executionName,
      pull_latest_files: runParameters?.pull_latest_files ?? false,
      pivot_results: runParameters?.pivot_results ?? false,
      query_params: {
        ...filteredRunParameters,
      },
    };

    // Only include output_storage_params if not null AND has changes
    if (
      !isOutputStorageParamsNull &&
      differentOutputStorageParams !== null &&
      Object.keys(differentOutputStorageParams).length > 0
    ) {
      reqBody.output_storage_params = differentOutputStorageParams;
    }

    // Only include run_instance if it has changed
    if (differentRunInstance !== null) {
      reqBody.run_instance = differentRunInstance;
    }

    // Only include execution_sub_group if it has changed
    if (differentExecutionSubGroup !== null) {
      reqBody.execution_sub_group = differentExecutionSubGroup;
    }

    // Only include validation_severity_level if it has changed
    if (current_severity_level !== original_severity_level) {
      reqBody.validation_severity_level = current_severity_level;
    }

    // Only include rule_execution_report_name if it has changed
    if (
      current_rule_execution_report_name !== original_rule_execution_report_name
    ) {
      reqBody.rule_execution_report_name = current_rule_execution_report_name;
    }

    // Only include validation_execution_report_name if it has changed
    if (
      current_validation_execution_report_name !==
      original_validation_execution_report_name
    ) {
      reqBody.validation_execution_report_name =
        current_validation_execution_report_name;
    }

    // Only include severity_column_names if configured and different from original
    if (Object.keys(severity_column_names).length !== 0) {
      const original_severity_column_names_payload = {
        1: originalSeverityColumnNames.high,
        2: originalSeverityColumnNames.medium,
        3: originalSeverityColumnNames.low,
      };
      const original_severity_column_names: any = Object.fromEntries(
        Object.entries(original_severity_column_names_payload).filter(
          ([_, v]) => v !== null
        )
      );

      const differentSeverityColumnNames = getDifferentValues(
        severity_column_names,
        original_severity_column_names
      );

      if (
        differentSeverityColumnNames !== null &&
        Object.keys(differentSeverityColumnNames).length > 0
      ) {
        reqBody.severity_column_names = differentSeverityColumnNames;
      }
    }

    // Only include inline_variables if it has changed
    if (differentInlineVariables !== null) {
      reqBody.inline_variables = differentInlineVariables;
    }

    // Attach scoring overrides only when scoring is enabled and the user has
    // modified values. Comparison overrides target `comparison_score_params`
    // (the engine still uses defaults for per-resource validation params).
    if (runParameters?.generate_score && scoreConfigOverride) {
      reqBody.score_config_params = {
        comparison_score_params: scoreConfigOverride,
      };
    }

    return reqBody;
  };

  useEffect(() => {
    const executeRule = () => {
      setValidationMessage([]);

      // Validate inline variables using viewInlineVariables (current state)
      // This ensures validation works even when inline_variables is not in the differential payload
      const ruleVariables = {
        ...viewInlineVariables?.rule_variables?.filterRule,
        ...viewInlineVariables?.rule_variables?.adhoc_queries,
      };

      if (ruleVariables && Object.keys(ruleVariables).length > 0) {
        Object.keys(ruleVariables).forEach((key) => {
          if (ruleVariables[key] === "") {
            setValidationMessage((prev) => [
              ...prev,
              {
                id: `Rule Variables`,
                message: `Please enter value for ${key}`,
              },
            ]);
          }
        });
      }

      if (
        viewInlineVariables?.resource_variables &&
        viewInlineVariables.resource_variables.length > 0
      ) {
        viewInlineVariables.resource_variables.forEach(
          (resource: { resource_vars: any; resource_name: any }) => {
            const resourceVars = resource.resource_vars;
            if (resourceVars) {
              Object.keys(resourceVars).forEach((key) => {
                if (resourceVars[key] === "") {
                  setValidationMessage((prev) => [
                    ...prev,
                    {
                      id: `Resource ${resource.resource_name} Variables`,
                      message: `Please enter value for ${key}`,
                    },
                  ]);
                }
              });
            }
          }
        );
      }

      if (
        viewInlineVariables?.comparison_research_query_variables &&
        Object.keys(viewInlineVariables.comparison_research_query_variables)
          .length > 0
      ) {
        const researchQueryVariables =
          viewInlineVariables.comparison_research_query_variables;
        if (researchQueryVariables) {
          Object.keys(researchQueryVariables).forEach((key) => {
            if (researchQueryVariables[key] === "") {
              setValidationMessage((prev) => [
                ...prev,
                {
                  id: `Research Query Variables`,
                  message: `Please enter value for ${key}`,
                },
              ]);
            }
          });
        }
      }

      // Build the payload after validation
      const reqBody = buildRuleExecutionPayload();
      setRuleExecutionPayload(reqBody);
    };
    if (checkValidation) executeRule();
  }, [checkValidation]);

  useEffect(() => {
    if (
      validationMessage.length === 0 &&
      ruleExecutionPayload &&
      Object.keys(ruleExecutionPayload).length > 0
    ) {
      setIsBackdropLoading(true);
      if (executionMode) {
        backgroundexecuteRuleById(Number(currentRuleId), ruleExecutionPayload)
          .then(() => {
            showToast(
              "Your rule execution is in the queue. We will notify you once it's done!",
              "warn"
            );
            navigate(`/rules-execution-history`);
          })
          .catch((error: any) => {
            console.error(error);
          })
          .finally(() => {
            setCheckValidation(false);
            setRuleExecutionPayload({});
            setIsBackdropLoading(false);
          });
      } else {
        executeRuleById(Number(currentRuleId), ruleExecutionPayload)
          .then((response: any) => {
            showToast("Rule execution successfully!", "success");
            navigate(
              `/rules-execution-history/${response?.rule_id}/${response?.id}/dashboard`,
              {
                state: {
                  rowData: response,
                  isRuleExecutionResponse: true,
                },
              }
            );
          })
          .catch((error: any) => {
            console.error(error);
          })
          .finally(() => {
            setCheckValidation(false);
            setRuleExecutionPayload({});
            setIsBackdropLoading(false);
          });
      }
    } else if (validationMessage.length > 0) {
      const temp = (
        <div>
          Not all fields are configured. Please check the following fields:
          {validationMessage.map((msg) => (
            <div>
              <span style={{ fontWeight: 900 }}>{msg.id}</span>-{msg.message}
            </div>
          ))}
        </div>
      );
      showToast(temp, "warning");
      setCheckValidation(false);
      return;
    }
  }, [validationMessage, ruleExecutionPayload]);

  const Summary = () => {
    return (
      <Box className="rule-execution-page compact-text-box-card">
        <Box className="text-box-card pt-0" sx={{ marginBottom: "12px" }}>
          <Box>
            <h2 className="page-title">
              Domain <span>{ruleData?.domain_name}</span>
            </h2>
          </Box>
          <Grid container spacing={4}>
            <Grid item xs={12} md={6} lg={6}>
              <h4>Primary Resource</h4>
              {ruleData?.rule_schema?.merge_rule?.primary_dataset ? (
                <table className="table">
                  <thead>
                    <tr>
                      <th className="pe-40">Resource</th>
                      <th className="pe-40">Keys</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="pe-40">
                        {getResourceNamebyId(
                          ruleData?.rule_schema?.merge_rule?.primary_dataset
                            ?.resource_id
                        )}
                      </td>
                      <td className="pe-40">
                        {ruleData?.rule_schema?.merge_rule?.primary_dataset?.merge_on?.join(
                          ", "
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              ) : (
                <p>No primary resource available</p>
              )}
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
              <h4>Secondary Resource</h4>
              {ruleData?.rule_schema?.merge_rule?.secondary_datasets ? (
                <table className="table">
                  <thead>
                    <tr>
                      <th className="pe-40">Resource</th>
                      <th className="pe-40">Keys</th>
                    </tr>
                  </thead>
                  <tbody>
                    {ruleData?.rule_schema?.merge_rule?.secondary_datasets?.map(
                      (dataset: {
                        resource_id: string | number | null | undefined;
                        merge_on: any[];
                      }) => (
                        <tr key={dataset.resource_id}>
                          <td className="pe-40">
                            {getResourceNamebyId(dataset.resource_id)}
                          </td>
                          <td className="pe-40">
                            {dataset.merge_on.join(", ")}
                          </td>
                        </tr>
                      )
                    )}
                  </tbody>
                </table>
              ) : (
                <p>No secondary resource available</p>
              )}
            </Grid>
          </Grid>
        </Box>
        <Box className="text-box-card pt-0" sx={{ marginBottom: "12px" }}>
          <Box>
            <h2 className="page-title">
              {" "}
              Rule <span>{ruleData?.name}</span>
            </h2>
          </Box>
          <Grid container spacing={4}>
            <Grid item xs={12} md={6} lg={6}>
              <Grid item xs={12} sx={{ marginBottom: "24px" }}>
                <h4>Domain Comparison Rules</h4>
                {ruleData?.rule_schema?.domain_comparison_rules &&
                ruleData?.rule_schema?.domain_comparison_rules.length > 0 ? (
                  <table className="table">
                    <thead>
                      <tr>
                        <th className="pe-20">Name</th>
                        <th className="pe-20">Column Name</th>
                        <th className="pe-20">Operator</th>
                      </tr>
                    </thead>
                    <tbody>
                      {ruleData?.rule_schema?.domain_comparison_rules?.map(
                        (rule: {
                          name: string | number | null | undefined;
                          column_name: string;
                          comparison_type: string;
                        }) => (
                          <tr key={rule.name}>
                            <td className="pe-20">{rule.name}</td>
                            <td className="pe-20">{rule.column_name}</td>
                            <td className="pe-20">
                              {getComparisonSymbol(rule.comparison_type)}
                            </td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </table>
                ) : (
                  <p>No domain comparison rules available</p>
                )}
              </Grid>
              <Grid item xs={12}>
                <h4 className="heading-hr">Resource Filter</h4>
                {ruleData?.rule_schema?.filter_rules &&
                ruleData?.rule_schema?.filter_rules.length > 0 ? (
                  <table className="table table-resource-filter mb-3">
                    <thead>
                      <tr>
                        <th className="pe-20 pb-10 width-180">Resource</th>
                        <th className="pe-20 pb-10">SQL Expression</th>
                      </tr>
                    </thead>
                    <tbody>
                      {ruleData?.rule_schema?.filter_rules?.map((rule: any) => (
                        <tr key={rule.name}>
                          <td className="pe-20">{rule.name}</td>
                          <td className="pe-20 ">
                            <Box className="word-break-all">
                              {rule?.sql_query?.length > 100 ? (
                                <ReadMoreLess
                                  data={rule.sql_query}
                                  charLimit={100}
                                />
                              ) : (
                                rule.sql_query || ""
                              )}
                            </Box>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <p>No Resource Filter available</p>
                )}
              </Grid>
              <Grid item xs={12}>
                <h4 className="heading-hr">Adhoc Queries</h4>
                {ruleData?.rule_schema?.adhoc_queries &&
                ruleData?.rule_schema?.adhoc_queries.length > 0 ? (
                  <table className="table table-resource-filter">
                    <thead>
                      <tr>
                        <th className="pe-20 pb-10 width-180">Name</th>
                        <th className="pe-20 pb-10">SQL Expression</th>
                      </tr>
                    </thead>
                    <tbody>
                      {ruleData?.rule_schema?.adhoc_queries?.map(
                        (query: any, index: number) => (
                          <tr key={index}>
                            <td className="pe-20">{query.name}</td>
                            <td className="pe-20 ">
                              <Box className="word-break-all">
                                {query.sql_query &&
                                query.sql_query.length > 100 ? (
                                  <ReadMoreLess
                                    data={query.sql_query}
                                    charLimit={100}
                                  />
                                ) : (
                                  query.sql_query || ""
                                )}
                              </Box>
                            </td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </table>
                ) : (
                  <p>No Adhoc Query available</p>
                )}
              </Grid>
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
              <h4>Custom Comparison Rules</h4>
              {ruleData?.rule_schema?.custom_comparison_rules &&
              ruleData?.rule_schema?.custom_comparison_rules.length > 0 ? (
                <table className="table w-100">
                  <thead>
                    <tr>
                      <th className="pe-20">Name</th>
                      <th className="pe-20">Column Name</th>
                      <th className="pe-20">Operator</th>
                      <th className="pe-20">Column Name</th>
                    </tr>
                  </thead>
                  <tbody>
                    {ruleData?.rule_schema?.custom_comparison_rules?.map(
                      (rule: any) => (
                        <tr key={rule.name}>
                          <td className="pe-20">{rule.name}</td>
                          <td className="pe-20">
                            <Box
                              sx={{ maxWidth: "135px", wordWrap: "break-word" }}
                            >
                              {rule?.left_operand?.column_name}
                            </Box>
                          </td>
                          <td className="pe-20">
                            {getComparisonSymbol(rule.comparison_type)}
                          </td>
                          <td className="pe-20">
                            <Box
                              sx={{ maxWidth: "135px", wordWrap: "break-word" }}
                            >
                              {rule?.right_operand?.column_name}
                            </Box>
                          </td>
                        </tr>
                      )
                    )}
                  </tbody>
                </table>
              ) : (
                <p>No custom comparison rules available</p>
              )}
            </Grid>
          </Grid>
        </Box>
        <Box className="text-box-card pt-0 mb-0">
          <Box>
            <h2 className="page-title">
              <span>Description</span>
            </h2>
            {ruleData?.description ? (
              <span className="break-word">{ruleData?.description}</span>
            ) : (
              <span>No description available</span>
            )}
          </Box>
        </Box>
      </Box>
    );
  };
  const handleChangeAccordion = (panel: any) => (_: any, isExpanded: any) => {
    // Check if any accordion is in edit mode
    if (
      isResourceEdit !== "" ||
      isEditResource ||
      isEditVariables ||
      isEditResearchQuery
    ) {
      showToast("Please save changes first!!", "warning");
      return;
    }
    setExpandedAccordion(isExpanded ? panel : null);
  };

  const handleChangeVariable = (event: any, inline_type: string, id?: any) => {
    const { name, value } = event.target;
    if (id && inline_type === "resource_variables") {
      setInlineVariables((prev: any) => ({
        ...prev,
        resource_variables: prev.resource_variables.map((resource: any) => {
          if (resource.resource_id === id) {
            return {
              ...resource,
              resource_vars: {
                ...resource.resource_vars,
                [name]: value,
              },
            };
          }
          return resource;
        }),
      }));
    } else if (inline_type === "filterRule") {
      setInlineVariables((prev: any) => ({
        ...prev,
        rule_variables: {
          ...prev.rule_variables,
          filterRule: {
            ...prev.rule_variables.filterRule,
            [name]: value,
          },
        },
      }));
    } else if (inline_type === "adhoc_queries") {
      setInlineVariables((prev: any) => ({
        ...prev,
        rule_variables: {
          ...prev.rule_variables,
          adhoc_queries: {
            ...prev.rule_variables.adhoc_queries,
            [name]: value,
          },
        },
      }));
    } else if (inline_type === "comparison_research_query_variables") {
      setInlineVariables((prev: any) => ({
        ...prev,
        comparison_research_query_variables: {
          ...prev.comparison_research_query_variables,
          [name]: value,
        },
      }));
    }
  };
  const handleSecondaryMergeResourceDialog = () => {
    setSecondaryMergeResourceDialog(false);
  };

  const onSaveSecondaryMergeResource = () => {
    setSecondaryMergeResourceDialog(false);
  };
  const handleExecuteSubmit = async () => {
    try {
      await executionNameSchema.validate(
        { execution_name: executionName },
        {
          abortEarly: false,
        }
      );
      setCheckValidation(true);
    } catch (validationErrors: any) {
      const newErrors: { [key: string]: string } = {};
      validationErrors.inner.forEach(
        (error: { path: string | number; message: string }) => {
          newErrors[error.path] = error.message;
        }
      );
      setErrors((prevErrors: any) => ({
        ...prevErrors,
        ...newErrors,
      }));
    }
  };

  // Handle copying payload to clipboard
  const handleCopyPayload = async (event: React.MouseEvent) => {
    event.stopPropagation(); // Prevent button click from triggering
    try {
      const payload = buildRuleExecutionPayload();
      const formattedPayload = JSON.stringify(payload, null, 2);
      await navigator.clipboard.writeText(formattedPayload);
      showToast("JSON copied to clipboard!", "success");
    } catch (err) {
      console.error("Failed to copy JSON:", err);
      showToast("Failed to copy JSON to clipboard", "error");
    }
  };

  const handleValidatePayload = async (payload: any) => {
    setIsValidating(true);
    try {
      const validateReqBody = {
        target_endpoint: `/rules/execute-with-in-body-query-params/${currentRuleId}`,
        method: "POST",
        body: payload,
        query_params: {},
        url_params: {},
      };
      const response = await validateEngineRequest(validateReqBody);
      setValidationResponse(response);
      if (response?.is_valid) {
        showToast("Payload is valid!", "success");
      }
    } catch (error: any) {
      showToast(error?.response?.data?.message || "Validation failed", "error");
    } finally {
      setIsValidating(false);
    }
  };

  // Memoized flag: true when inlineVariables contains at least one variable of any type.
  // Used to conditionally render the Variables Accordion.
  const hasInlineVariables = useMemo(() => {
    return (
      (inlineVariables?.rule_variables?.adhoc_queries &&
        Object.keys(inlineVariables.rule_variables.adhoc_queries).length > 0) ||
      (inlineVariables?.rule_variables?.filterRule &&
        Object.keys(inlineVariables.rule_variables.filterRule).length > 0) ||
      (inlineVariables?.resource_variables &&
        inlineVariables.resource_variables.length > 0) ||
      (inlineVariables?.comparison_research_query_variables &&
        Object.keys(inlineVariables.comparison_research_query_variables)
          .length > 0)
    );
  }, [inlineVariables]);

  // Helper function to check if there are any variables (used or unused)
  const hasAnyVariables = () => {
    if (!viewInlineVariables) return false;

    // Check for rule variables (filterRule + adhoc_queries) vs used_rule_variables
    const allRuleVarKeys = [
      ...Object.keys(viewInlineVariables?.rule_variables?.filterRule || {}),
      ...Object.keys(viewInlineVariables?.rule_variables?.adhoc_queries || {}),
    ];
    const hasRuleVariables =
      allRuleVarKeys.length >
      (viewInlineVariables?.used_rule_variables?.length ?? 0);

    // Check for resource variables
    const hasResourceVariables =
      viewInlineVariables?.resource_variables &&
      viewInlineVariables.resource_variables.length > 0 &&
      viewInlineVariables.resource_variables.some(
        (resource: any) =>
          resource?.resource_vars &&
          Object.keys(resource.resource_vars).length >
            viewInlineVariables?.used_variables?.find(
              (r: any) => r?.resource_id === resource?.resource_id
            )?.merged_used_variables?.length
      );

    // Check for research query variables
    const hasResearchQueryVariables =
      viewInlineVariables?.comparison_research_query_variables &&
      Object.keys(viewInlineVariables.comparison_research_query_variables)
        .length > viewInlineVariables?.used_research_query_variables?.length;

    // If showing used variables, check if there are any used variables
    if (showVariables === "used") {
      const usedVars = viewInlineVariables?.used_variables;

      // Check used rule variables
      const hasUsedRuleVars =
        viewInlineVariables?.used_rule_variables &&
        viewInlineVariables.used_rule_variables.length > 0;

      const hasUsedResearchQueryVars =
        viewInlineVariables?.used_research_query_variables &&
        viewInlineVariables.used_research_query_variables.length > 0;

      // Check used resource variables
      const hasUsedResourceVars =
        usedVars &&
        usedVars.some(
          (resource: any) => resource?.merged_used_variables?.length > 0
        );

      // Check used resource column detail variables
      return hasUsedRuleVars || hasUsedResourceVars || hasUsedResearchQueryVars;
    }

    // If showing unused variables, check if there are any variables that are not used
    return (
      hasRuleVariables || hasResourceVariables || hasResearchQueryVariables
    );
  };

  return (
    <>
      <Loader isLoading={isBackdropLoading} />
      <Loader isLoading={isLoading} />

      {isReRunData?.isReRun && (
        <Box className="re-run-header">
          <h2>Re-Run</h2>
        </Box>
      )}
      <div
        className="accordion-panel"
        style={{ marginBottom: "0", marginTop: "8px" }}
      >
        <Box>
          <ExecutionName
            handleChangeAccordion={handleChangeAccordion}
            errors={errors}
            setErrors={setErrors}
            executionName={executionName}
            setExecutionName={setExecutionName}
            executionMode={executionMode}
            setExecutionMode={setExecutionMode}
            runParameters={runParameters}
            setRunParameters={setRunParameters}
            setIsLoading={setIsLoading}
            isReRun={isReRunData?.isReRun || false}
          />
          <Accordion
            className="heading-bold box-shadow color-palette color-palette-1"
            expanded={expandedAccordion === "summary"}
            onChange={handleChangeAccordion("summary")}
          >
            <AccordionSummary
              aria-controls="panel1d-content"
              id="panel1d-header"
              expandIcon={<ExpandMoreIcon />}
            >
              Summary
            </AccordionSummary>
            <AccordionDetails>
              <Summary />
            </AccordionDetails>
          </Accordion>

          {/* Research Query Accordion */}
          {researchQueryDetailData &&
            researchQueryDetailData?.research_queries?.length > 0 && (
              <Accordion
                className="mt-6 heading-bold box-shadow color-palette color-palette-1"
                expanded={expandedAccordion === "research-queries"}
                onChange={handleChangeAccordion("research-queries")}
              >
                <AccordionSummary
                  aria-controls="research-queries-content"
                  id="research-queries-header"
                  expandIcon={<ExpandMoreIcon />}
                >
                  Research Queries
                </AccordionSummary>
                <AccordionDetails sx={{ paddingTop: "16px" }}>
                  <RuleResearchQuery
                    researchQuery={researchQueryDetailData}
                    setResearchQuery={setResearchQueryDetailData}
                    isFromExecution={true}
                    isEditResearchQuery={isEditResearchQuery}
                    setIsEditResearchQuery={setIsEditResearchQuery}
                    ruleDetailData={ruleData}
                    allowExecutionOverride={true}
                  />
                </AccordionDetails>
              </Accordion>
            )}

          {resourcesData && resourcesData.length > 0 && (
            <>
              <Accordion
                className="mt-6 heading-bold box-shadow color-palette color-palette-2"
                expanded={expandedAccordion === "all-resources"}
                onChange={handleChangeAccordion("all-resources")}
              >
                <AccordionSummary
                  aria-controls="panel2d-content"
                  id="panel2d-header"
                  expandIcon={<ExpandMoreIcon />}
                >
                  Resource(s)
                </AccordionSummary>
                <AccordionDetails sx={{ paddingTop: "0px !important" }}>
                  {resourcesData.map((resource: any, index: number) => (
                    <>
                      <React.Fragment key={resource?.id}>
                        <RuleExecutionTab
                          resourcesData={resourcesData}
                          resourceData={resource}
                          isLoading={isBackdropLoading}
                          setResourcesData={setResourcesData}
                          setOriginalResourcesData={setOriginalResourcesData}
                          setIsLoading={setIsLoading}
                          fileProcessingData={fileProcessingData}
                          fileStreamIndex={index}
                          setViewInlineVariables={setViewInlineVariables}
                          viewInlineVariables={viewInlineVariables}
                          resource_type={`main-resource-${resource?.id}`}
                          resourcePath={`resources[${index}]`}
                          setSecondaryMergeResourceDialog={
                            setSecondaryMergeResourceDialog
                          }
                          setResourceDataWithSecMerge={
                            setResourceDataWithSecMerge
                          }
                          setIsEditSecondaryResource={
                            setIsEditSecondaryResource
                          }
                        />
                      </React.Fragment>
                    </>
                  ))}
                </AccordionDetails>
              </Accordion>
            </>
          )}

          <RunParameters
            runParameters={runParameters}
            setRunParameters={setRunParameters}
            isEditResource={isEditResource}
            setIsEditResource={setIsEditResource}
            setIsLoading={setIsLoading}
            severityColumnNames={severityColumnNames}
            setSeverityColumnNames={setSeverityColumnNames}
            expandedAccordion={expandedAccordion}
            handleChangeAccordion={handleChangeAccordion}
            feature="ruleExecution"
            isReRun={isReRunData?.isReRun}
            resourcesData={resourcesData}
          />

          <ScoringConfigOverrideAccordion
            type="comparison"
            generateScore={!!runParameters?.generate_score}
            currentConfig={comparisonScoringConfig}
            expanded={expandedAccordion === "scoring-config-overrides"}
            onChange={handleChangeAccordion("scoring-config-overrides")}
            onOverrideChange={setScoreConfigOverride}
            disabled={isEditResource}
            nameOptions={comparisonCheckNameOptions}
          />

          <Accordion
            className="mt-6 heading-bold box-shadow color-palette color-palette-1"
            expanded={expandedAccordion === "result-storage-parameters"}
            onChange={handleChangeAccordion("result-storage-parameters")}
          >
            <AccordionSummary
              aria-controls="panel1d-content"
              id="panel1d-header"
              expandIcon={<ExpandMoreIcon />}
            >
              Result Storage Parameters
            </AccordionSummary>
            <AccordionDetails sx={{ paddingTop: "16px" }}>
              <ResultStorageParameters
                resultStorageParameters={resultStorageParameters}
                setResultStorageParameters={setResultStorageParameters}
                isEditResource={isEditResource}
                setIsEditResource={setIsEditResource}
                setIsLoading={setIsLoading}
                isFromRule={true}
                isReRun={isReRunData?.isReRun}
              />
            </AccordionDetails>
          </Accordion>

          {hasInlineVariables && (
            <Accordion
              className="mt-6 heading-bold box-shadow color-palette color-palette-1"
              expanded={expandedAccordion === "inline-variables"}
              onChange={handleChangeAccordion("inline-variables")}
            >
              <AccordionSummary
                aria-controls="panel1d-content"
                id="panel1d-header"
                expandIcon={<ExpandMoreIcon />}
              >
                Variables
              </AccordionSummary>
              <AccordionDetails sx={{ paddingTop: "16px" }}>
                {!isEditVariables ? (
                  <RuleInlineVariables
                    handleChangeVariable={handleChangeVariable}
                    inlineVariables={viewInlineVariables}
                    isReadOnly={true}
                    showVariables={showVariables}
                    setShowVariables={setShowVariables}
                    isDisplayUsedVariable={true}
                  />
                ) : (
                  <RuleInlineVariables
                    handleChangeVariable={handleChangeVariable}
                    inlineVariables={inlineVariables}
                    isReadOnly={false}
                    showVariables={showVariables}
                    setShowVariables={setShowVariables}
                    isDisplayUsedVariable={true}
                  />
                )}
                {!isEditVariables ? (
                  hasAnyVariables() ? (
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md
                      sx={{ justifyContent: "flex-end", display: "flex" }}
                    >
                      <button
                        className="btn-nostyle icon-btn-edit"
                        onClick={() => {
                          setIsEditVariables(true);
                          setInlineVariables(viewInlineVariables);
                          setInitialInlineVariables(
                            JSON.parse(JSON.stringify(viewInlineVariables))
                          );
                        }}
                      >
                        <IconBtnEditBase ariaLabel="Edit variables" />
                      </button>
                    </Grid>
                  ) : (
                    <table className="inline-variables-table">
                      <tbody>
                        <tr>
                          <td className="text-center">No variables found</td>
                        </tr>
                      </tbody>
                    </table>
                  )
                ) : (
                  <Grid
                    item
                    xs
                    sx={{
                      display: "flex",
                      alignItems: "flex-end",
                      justifyContent: "flex-end",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        columnGap: "8px",
                        flexWrap: "wrap",
                      }}
                    >
                      <Button
                        color="secondary"
                        variant="contained"
                        onClick={() => {
                          setIsEditVariables(false);
                          setInlineVariables(viewInlineVariables);
                        }}
                        className="btn-orange btn-dark"
                      >
                        Cancel
                      </Button>
                      <Button
                        color="secondary"
                        variant="contained"
                        onClick={() => {
                          setViewInlineVariables(inlineVariables);
                          setIsEditVariables(false);
                        }}
                        className="btn-orange"
                        disabled={!hasChanges}
                      >
                        <SaveOutlinedIcon /> &nbsp; Save
                      </Button>
                    </Box>
                  </Grid>
                )}
              </AccordionDetails>
            </Accordion>
          )}
          {filterFormData?.filter_rules &&
            filterFormData?.filter_rules?.length > 0 && (
              <CustomAccordian
                expandId="filter-rules"
                title="Filter Rules"
                handleChangeAccordion={handleChangeAccordion}
                isEnabled={true}
                topMargin={6}
                className="color-palette color-palette-1"
              >
                {!isEditFilters ? (
                  <FilterRules formData={filterFormData} isViewOnly={true} />
                ) : (
                  <CustomMultipleResourceRuleFilters
                    formData={filterFormData}
                    resourcesData={resourcesData}
                    setFormData={setFilterFormData}
                    setViewInlineVariables={setViewInlineVariables}
                    isEditFilters={isEditFilters}
                    setIsEditFilters={setIsEditFilters}
                  />
                )}
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md
                  sx={{
                    justifyContent: "flex-end",
                    display: "flex",
                    marginTop: "8px",
                  }}
                >
                  {!isEditFilters && (
                    <button
                      className="btn-nostyle icon-btn-edit"
                      onClick={() => {
                        setIsEditFilters((prev) => !prev);
                      }}
                    >
                      <IconBtnEditBase ariaLabel="Edit filter rules" />
                    </button>
                  )}
                </Grid>
              </CustomAccordian>
            )}
          {ruleData?.rule_schema?.adhoc_queries &&
            ruleData?.rule_schema?.adhoc_queries.length > 0 && (
              <CustomAccordian
                expandId="adhoc-query"
                title="Adhoc Query"
                handleChangeAccordion={handleChangeAccordion}
                isEnabled={true}
                topMargin={6}
                className="color-palette color-palette-1"
              >
                <AddMultipleGridList
                  gridValue={ruleData?.rule_schema?.adhoc_queries}
                  setGridValue={() => {}}
                  isViewOnly={true}
                  buttonName=" "
                  errors={{}}
                  setErrors={() => {}}
                />
              </CustomAccordian>
            )}
          {!isEditResource && isResourceEdit === "" && (
            <FlexBetween
              gap="3rem"
              sx={{
                marginTop: 2,
                display: "flex",
                justifyContent: "flex-end",
                gap: "1rem",
              }}
            >
              {/* View JSON Button with integrated Copy Icon */}
              <Button
                className="btn-orange btn-dark"
                color="secondary"
                variant="contained"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0,
                  padding: "6px 16px",
                  position: "relative",
                }}
                onClick={() => {
                  const payload = buildRuleExecutionPayload();
                  setExecuteRulePayload(payload);
                  setIsPayloadDialogOpen(true);
                }}
              >
                {/* Left Section: View JSON Text */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    paddingRight: "12px",
                  }}
                >
                  View JSON
                </Box>

                {/* Vertical Separator */}
                <Box
                  sx={{
                    width: "1px",
                    height: "24px",
                    backgroundColor: "rgba(255, 255, 255, 0.3)",
                    marginX: "8px",
                  }}
                />

                {/* Right Section: Copy Icon */}
                <Box
                  onClick={handleCopyPayload}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    paddingLeft: "8px",
                    paddingRight: "4px",
                    cursor: "pointer",
                    "&:hover": {
                      opacity: 0.8,
                    },
                  }}
                  title="Copy JSON to clipboard"
                >
                  <ContentCopyIcon sx={{ fontSize: "18px" }} />
                </Box>
              </Button>

              <Button
                type="submit"
                className="btn-orange"
                color="secondary"
                variant="contained"
                onClick={handleExecuteSubmit}
              >
                {isReRunData?.isReRun ? "Re-Execute" : "Execute"}
              </Button>
            </FlexBetween>
          )}
        </Box>
      </div>
      <SecondaryMergeResourceDialog
        secondaryMergeResourceDialog={secondaryMergeResourceDialog}
        handleSecondaryMergeResourceDialog={handleSecondaryMergeResourceDialog}
        resourceDataWithSecMerge={resourceDataWithSecMerge}
        setResourceDataWithSecMerge={setResourceDataWithSecMerge}
        onSaveSecondaryMergeResource={onSaveSecondaryMergeResource}
        fetchedResourcesData={fetchedResourcesData}
        setIsLoading={setIsLoading}
        isEditSecondaryResource={isEditSecondaryResource}
        mergeColumnsLength={mergeColumnsLength}
        fetchedConnectionKeys={fetchedConnectionKeys}
        secondaryResourceData={secondaryResourceData}
        setSecondaryResourceData={setSecondaryResourceData}
        setResourcesData={setResourcesData}
        resourcesData={resourcesData}
        setOriginalResourcesData={setOriginalResourcesData}
      />
      <ViewPayloadDialog
        openDialog={isPayloadDialogOpen}
        dialogTitle="Rule Execution JSON"
        payload={executeRulePayload}
        handleDialogClose={() => {
          setIsPayloadDialogOpen(false);
          setValidationResponse(null);
        }}
        onValidate={handleValidatePayload}
        isValidating={isValidating}
        validationResponse={validationResponse}
      />
    </>
  );
};

export default RuleExecution;
